import { Box, Text } from '@chakra-ui/react';
import React from 'react';

export default function DetailSelloutCard({ title, content }) {
    return (
        <Box>
            <Text fontWeight={'bold'} mb={1} fontSize={'14px'}>
                {title}
            </Text>
            <Text fontSize={'14px'}>{content}</Text>
        </Box>
    );
}
